export default class Service {

}
